import { render, staticRenderFns } from "./modalSub.vue?vue&type=template&id=30460e74&scoped=true&"
import script from "./modalSub.vue?vue&type=script&lang=js&"
export * from "./modalSub.vue?vue&type=script&lang=js&"
import style0 from "./modalSub.vue?vue&type=style&index=0&id=30460e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30460e74",
  null
  
)

export default component.exports